module.exports = __webpack_public_path__ + "img/Guizhou-speed.867fe702.png";